
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { TaskActionModel } from './Entities.GormCrm.TaskAction';
import { Model, ModelProperty } from 'models/Model';


export class CreateTaskflowFromTagRequestModel extends Model<CreateTaskflowFromTagRequestModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'taskflowTag', type: 'string' },
		{ name: 'companyId', type: 'string' },
		{ name: 'actions', type: 'TaskActionModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new TaskActionModel }, properties: () => { return TaskActionModel.classProperties } },
		{ name: 'deadline', type: 'Date' },
		{ name: 'selectedProductPlanIds', type: 'string[]', isArray: true }
	];
	[key: string]: any;
	
	public taskflowTag: string;
	public companyId?: string;
	public actions: TaskActionModel[];
	public deadline?: Date;
	public selectedProductPlanIds: string[];
    
	constructor(){
		super();
		this.taskflowTag = '';
		this.companyId = undefined;
		this.actions = [];
		this.deadline = undefined;
		this.selectedProductPlanIds = [];
		
	}
	getProperties(){
		return CreateTaskflowFromTagRequestModel.classProperties;
	}
}

